import React from "react";
import SidebarAntd from "../SidebarAntd/SidebarAntd.jsx";
import Sidebar from "../Sidebar/Sidebar.jsx";

const AdminLayout = ({ children }) => {
  return <Sidebar>{children}</Sidebar>;
};

export default AdminLayout;
